import { ActionDataType, UserDataState } from './user.types';
import { SIGN_IN_UP_ACTIONS } from './user.actions';

const initialState: UserDataState = {
  user: undefined,
  urbainUser: null,
  loading: false,
  error: '',
  showSignInUp: { login: false, signUp: false },
  showConfirm: false,
  possibleNewUser: null
};

export default function launchReducer(state = initialState, action: ActionDataType) {
  switch (action.type) {
    case SIGN_IN_UP_ACTIONS.HIDE_SIGN_IN_UP:
    case SIGN_IN_UP_ACTIONS.SHOW_SIGN_IN_UP:
      return { ...state, showSignInUp: { ...action.data } };
    case SIGN_IN_UP_ACTIONS.SET_USER:
      return { ...state, user: action.data };
    case SIGN_IN_UP_ACTIONS.SET_URBAIN_USER:
      return { ...state, urbainUser: action.data };
    case SIGN_IN_UP_ACTIONS.SET_POSSIBLE_NEW_USER:
      return { ...state, possibleNewUser: action.data };
    case SIGN_IN_UP_ACTIONS.SHOW_SIGN_CONFIRM:
      return { ...state, showConfirm: action.data };
    default:
      return state;
  }
}
